import React from 'react';
import colors from '../../util/colors';
import * as fonts from '../../util/fonts';
import {useHistory} from 'react-router-dom';

import {MenuItem} from './types';

const HoverableSubItem = ({
  label,
  onClick,
  url,
}: {
  label: string;
  onClick: () => void;
  url: string;
}) => {
  const [isHovering, setIsHovering] = React.useState(false);
  const history = useHistory();

  // Check if this sub-item is currently active based on the URL
  const isActive = history.location.pathname.includes(url);

  return (
    <div
      className="app-nav-menu-sub-item"
      onClick={onClick}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      style={{
        ...fonts.M,
        ...fonts.SemiBold,
        fontSize: '14px',
        color: isActive || isHovering ? '#00B1D1' : colors.black,
      }}>
      {label}
    </div>
  );
};

interface Props {
  item: MenuItem;
  busFuncMap: {[key: string]: any};
  selectedBu: string;
  handleNavigate: (url: string, selector: string[]) => void;
}

export const SubMenu = ({
  item,
  busFuncMap,
  selectedBu,
  handleNavigate,
}: Props) => {
  return (
    <div>
      <div className="app-nav-menu-selected-page-label" />
      <div className="app-nav-menu-dropdown">
        <div className="app-nav-menu-dropdown-content">
          {item.subItems?.map((subItem) =>
            busFuncMap[selectedBu]?.map((func: any) => {
              if (
                func?.isVisible &&
                subItem.funct === func?.featureTemplateAlias
              ) {
                return (
                  <HoverableSubItem
                    key={subItem.funct + '-' + subItem.label}
                    label={subItem.label}
                    url={subItem.url}
                    onClick={() =>
                      handleNavigate(subItem.url, item.selector as string[])
                    }
                  />
                );
              }
              return null;
            })
          )}
        </div>
      </div>
    </div>
  );
};
